/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

export enum AttributeNames {
  EVENT_TYPE = 'event_type',
  TARGET_ELEMENT = 'target_element',
  TARGET_XPATH = 'target_xpath',
  URL_FULL = 'url.full',
}
